export default __webpack_public_path__ + "static/SiemensSans-Black-b29c4c91442cd86fbdc1ae645b5e354a.woff";